export default {
    PATIENT_NOTES: ({ patientNotes }) => patientNotes,
    GET_PATIENT_NOTES_LOADING: ({ getPatientNotesLoading }) => getPatientNotesLoading,
    APPROVE_NOTE_LOADING: ({ approveNoteLoading }) => approveNoteLoading,
};